<template>
  <div class="container">
    <div>
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="订单记录">
          <div class="table-responsive">
            <table class="table table-striped table-primary table-bordered">
              <thead>
              <tr>
                <th>订单号</th>
                <th>商品</th>
                <!--                <th>服务ID</th>-->
                <th>链接</th>
                <!--                <th>需付</th>-->
                <!--                <th>折扣</th>-->
                <th>付款</th>
                <th>状态</th>
                <th>购买量</th>
                <th>待完成量</th>
                <th>余额</th>
                <th>创建时间</th>
                <!-- <th>状态</th> -->
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in list" :key="item.Id">
                <td>{{ item.id }}</td>
                <td>{{ item.cn }}</td>
                <!--                <td>{{ item.services_id }}</td>-->
                <!--                    <td>{{ item.services_price | toDecimal }}</td>-->
                <td>{{ item.ApiServicesLink }}</td>
                <!--                <td>{{ item.need_amount | toDecimal }}</td>-->
                <!--                <td>{{ item.sale_rate | toDecimal }}折</td>-->
                <td>{{ item.pay_amount | toDecimal }}</td>
                <td style="color: rgb(29, 142, 242);">
                  {{
                    item.ApiStatus == "" || item.ApiStatus == "Pending" || item.ApiStatus == undefined ? "处理中" : item.ApiStatus.replace("Processing", "处理中").replace("In progress", "处理中").replace("Partial", "完成部分").replace("Canceled", "退款").replace("Completed", "已完成")
                  }}
                </td>
                <td>{{ item.services_num }}</td>
                <td>{{item.ApiRemains == nul ? "":item.ApiRemains.toString().replace("-","赠送") }}</td>
                <td>{{ item.balance | toDecimal }}</td>
                <td>{{ item.CreateTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="账单记录" force-render>
          <div class="table-responsive">
            <table class="table table-striped table-primary table-bordered">
              <thead>
              <tr>
                <th>金额</th>
                <th>备注</th>
                <th>状态</th>
                <th>创建时间</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in list" :key="item.Id">
                <td>{{ item.recharge_amount | toDecimal }}</td>
                <td>{{ item.remark }}</td>
                <td>{{ item.status == 0 ? "待到账" : "已到账" }}</td>
                <td>{{ item.create_time }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="微信充值记录" force-render>
          <div class="table-responsive">
            <table class="table table-striped table-primary table-bordered">
              <thead>
              <tr>
                <th>用户</th>
                <th>单号</th>
                <!--                <th>微信单号</th>-->
                <th>支付结果</th>
                <th>创建时间</th>
                <th>金额</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in list" :key="item.Id">
                <td>{{ item.mobile }}</td>
                <td>{{ item.out_trade_no }}</td>
                <!--                <td>{{ item.transaction_id == "" ? "待支付" : item.transaction_id }}</td>-->
                <td>{{ item.trade_state_desc == "" ? "待支付" : item.trade_state_desc }}</td>
                <td>{{ item.success_time == "" ? "待支付" : item.success_time }}</td>
                <td>{{ item.amount | toDecimal }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div class="pagein-right">
        <a-pagination
            v-model="current"
            :total="total"
            show-less-items
            :pageSize="page_size"
            @change="servise"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {getOrderList, getRechargeList, getUserWXpayList} from "@/api/mine";

// import { mapState } from 'vuex'
export default {
  data() {
    return {
      list: [],
      page_size: 10,
      current: 1,
      total: 0,
      lists: this.$store.state.user,
      key: 1,
    };
  },
  // computed: {
  //   ...mapState(['user'])
  // },
  mounted() {
    // this.getUser();
  },
  methods: {
    callback(key) {
      this.page_size = 10;
      this.current = 1;
      this.key = key;
      if (key == 1) {
        this.getOrder();
      } else if (key == 2) {
        this.getRecharge();
      } else if (key == 3) {
        this.getUserWXpay()
      }
    },
    getOrder() {
      var params = {
        union_id: this.lists.unionid,
        page: this.current,
        page_size: this.page_size,
      };
      getOrderList(params).then((res) => {
        if (res.code == 200) {
          this.list = res.data.orders;
          this.total = res.data.count;
        }
      });
    },
    getRecharge() {
      var params = {
        union_id: this.lists.unionid,
        page: this.current,
        page_size: this.page_size,
      };
      getRechargeList(params).then((res) => {
        if (res.code == 200) {
          this.list = res.data.re_orders;
          this.total = res.data.count;
        }
      });
    },
    getUserWXpay() {
      var params = {
        union_id: this.lists.unionid,
        page: this.current,
        page_size: this.page_size,
      };
      getUserWXpayList(params).then((res) => {
        if (res.code == 200) {
          console.log(res)
          this.list = res.data.re_orders;
          this.total = res.data.count;
        }
      });
    },
    servise(e) {
      this.current = e;
      if (this.key == 1) {
        this.getOrder();
      } else if (this.key == 2) {
        this.getRecharge();
      } else if (this.key == 3) {
        this.getUserWXpay()
      }
    },
  },
};
</script>
<style scoped>
.pagein-left {
  float: left;
}

.pagein-right {
  float: right;
}

.container {
  min-height: 500px !important;
}

/deep/ tr, th, td {
  text-align: center !important;

}
</style>